<template>
	<div v-editable="blok">
		<NuxtLink :to="linkPath(blok.link_url) || '/'">
			{{ blok.link_name }}
			<ArrowRightIcon v-if="showArrow" class="inline ml-2 w-4 align-sub" />
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
import type { BlokSimpleLink } from "~/types/storyblok/storyblok";
import { ArrowRightIcon } from "@heroicons/vue/24/outline";

interface Props {
	blok: BlokSimpleLink;
	showArrow?: boolean;
}
const { blok } = defineProps<Props>();

const { linkPath } = useStoryblokLink();
</script>
